import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { Breadcrumbs } from "baseui/breadcrumbs";
import { StyledLink } from "baseui/link";
import { ParagraphXSmall } from "baseui/typography";
import { useParams } from "react-router-dom";
import { AppNavigationBar } from "../components/Navigation";
import { useGetResourceGroupByIdQuery } from "../services/resourceGroups/resourceGroupApi";
import { useGetSubscriptionByIdQuery } from "../services/resourceGroups/subscriptionApi";
import { useGetTenantByIdQuery } from "../services/resourceGroups/tenantApi";

export function BasicPageLayout(props) {
  const prms = useParams();
  const subscriptionId = prms.subscriptionId ?? "";
  const resourceGroupId = prms.resourceGroupId ?? "";
  const tenantId = prms.tenantId ?? "";
  const [css, theme] = useStyletron();

  const { data: subscription } = useGetSubscriptionByIdQuery(subscriptionId);
  const { data: tenant } = useGetTenantByIdQuery(tenantId, { skip: !tenantId });
  const { data: resourceGroup } = useGetResourceGroupByIdQuery(resourceGroupId, { skip: !resourceGroupId });

  return (
    <>
      <AppNavigationBar subscriptionId={subscriptionId} />
      <Block
        maxWidth="1280px"
        className={css({
          margin: "0 auto !important",
          float: "none",
        })}>
        <Block margin={theme.sizing.scale800}>
          <ParagraphXSmall>
            <Breadcrumbs
              overrides={{
                ListItem: {
                  style: ({ $theme }) => ({
                    fontSize: $theme.typography.ParagraphXSmall.fontSize,
                  }),
                },
              }}>
              <StyledLink href="/subscriptions">{"Home"}</StyledLink>
              {tenant && <StyledLink href={`/subscriptions/${subscriptionId}`}>{subscription?.name}</StyledLink>}
              {resourceGroup && <StyledLink href={`/subscriptions/${subscriptionId}`}>{subscription?.name}</StyledLink>}
            </Breadcrumbs>
          </ParagraphXSmall>
          <Block>{props.children}</Block>
        </Block>
      </Block>
    </>
  );
}
